const topBar = document.querySelector( '.localads-top-bar' );
if ( topBar ) {
	const closeBtn = topBar.querySelector( '.localads-top-bar__close' );
	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', () => {
			topBar.style.overflow = 'hidden';
			topBar.style.maxHeight = topBar.scrollHeight + 'px';
			requestAnimationFrame( () => {
				topBar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
				topBar.style.maxHeight = '0';
				topBar.style.opacity = '0';
			} );
			topBar.addEventListener( 'transitionend', () => {
				topBar.classList.add( 'is-hidden' );
			}, { once: true } );
		} );
	}
}
